import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import Panel from '../../panel'
import Union from '../assets/Union'
import Category from './Category'
import Link from '../assets/Link'

const SortableList = SortableContainer(({ children }) => children)
const SortableItem = SortableElement(({ children }) => children)

const onSortEnd = ({ oldIndex, newIndex }, list) => {
  return arrayMove(list, oldIndex, newIndex)
}

const DragHandle = SortableHandle(() => (
  <span className='category-manager_union-icon'>
    <Union />
  </span>)
)

const TitleComponent = (parentCategory, editCategoryLink) => (
  <div className='category-manager_panel-title'>
    <div className='category-manager_panel-title-left'>
      <DragHandle />
      <span className='category-manager_category-title'>{parentCategory.title}</span>
    </div>
    <div className='category-manager_panel-title-right' >
      <a href={`${editCategoryLink}?id=${parentCategory.id}`}>Edit</a>
      <a href={parentCategory.url}
        target='_blank'
        className='category-manager_link-icon'>
        <Link />
      </a>
    </div>
  </div>
)

const ParentCategory = (props) => {
  const parentCategory = props.parentCategory

  return (
    <Panel class={`qa-category-${parentCategory.id} qa-parent-category-${parentCategory.id}`} title={TitleComponent(parentCategory, props.editCategoryLink)}>
      <SortableList
        onSortEnd={(prev) => props.onCategorySorted(onSortEnd(prev, props.parentCategory.children), props.idx)}
        useDragHandle
        lockAxis='y'
        axis='y'
        useWindowAsScrollContainer>
        <ul className='category-manager_category-container'>
          {
            parentCategory.children.map((category, idx) => (
              <SortableItem index={idx} key={category.id}>
                <Category
                  category={category}
                  editCategoryLink={props.editCategoryLink}
                />
              </SortableItem>
            ))
          }
        </ul>
      </SortableList>
      <div className='category-manager_add-category-button'>
        <a href={`${props.addCategoryLink}?parentId=${parentCategory.id}`}
          className='btn btn-primary'>
          Add category
        </a>
      </div>
    </Panel>
  )
}

export default ParentCategory
